// import { Link } from 'react-router-dom';
// import { useState } from 'react';
// import websiteLogo from '../assets/website_logo_header.png';

// const servicesData = [
//   {
//     id: 1,
//     title: 'AI & Data Services',
//     subItems: [
//       { name: 'Internet & Web Research Services', slug: 'internet-web-research-services' },
//       { name: 'Sentiment Analysis', slug: 'sentiment-analysis' },
//       { name: 'Search Relevance', slug: 'search-relevance' },
//       { name: 'Search Data Testing', slug: 'search-data-testing' },
//       { name: 'Product Data Management', slug: 'product-data-management' },
//       { name: 'Store Checks', slug: 'store-checks' },
//       { name: 'Mystery Checks', slug: 'mystery-checks' },
//       { name: 'Surveys', slug: 'surveys' }
//     ]
//   },
//   {
//     id: 2,
//     title: 'Data Annotation & Dataset Solutions',
//     subItems: [
//       { name: 'Categorization & Tagging', slug: 'categorization-tagging' },
//       { name: 'Product Categorization & Tagging', slug: 'product-categorization-tagging' },
//       { name: 'Image & Video Tagging', slug: 'image-video-tagging' },
//       { name: 'Video Analysis', slug: 'video-analysis' },
//       { name: 'Image Annotation', slug: 'image-annotation' },
//       { name: 'Human in the Loop Services', slug: 'human-in-the-loop-services' },
//       { name: 'AI Content Editing & Creation', slug: 'ai-content-editing-creation' }
//     ]
//   },
//   {
//     id: 3,
//     title: 'AI Training Dataset Development',
//     subItems: [
//       { name: 'AI Datasets for ML', slug: 'ai-datasets-for-ml' },
//       { name: 'Audio & Voice Datasets', slug: 'audio-voice-datasets' },
//       { name: 'LLM Dataset Services', slug: 'llm-dataset-services' },
//       { name: 'Image & Photo Datasets', slug: 'image-photo-datasets' },
//       { name: 'Face Recognition Training Data', slug: 'face-recognition-training-data' },
//       { name: 'Video Datasets', slug: 'video-datasets' }
//     ]
//   },
//   {
//     id: 4,
//     title: 'Testing & Quality Assurance',
//     subItems: [
//       { name: 'Mobile App Testing', slug: 'mobile-app-testing' },
//       { name: 'Store Checks (QA field audits)', slug: 'store-checks-qa-field-audits' },
//       { name: 'Search Data Test', slug: 'search-data-test' },
//       { name: 'Mystery Checks (Customer experience QA)', slug: 'mystery-checks-customer-experience-qa' }
//     ]
//   },
//   {
//     id: 5,
//     title: 'App & Web Development',
//     subItems: [
//       { name: 'Mobile App Development (iOS & Android)', slug: 'mobile-app-development-ios-android' },
//       { name: 'Website Development', slug: 'website-development' },
//       { name: 'Web App UI/UX Design', slug: 'web-app-ui-ux-design' },
//       { name: 'Template Design', slug: 'template-design' }
//     ]
//   },
//   {
//     id: 6,
//     title: 'Creative & Graphic Design Services',
//     subItems: [
//       { name: 'Logo Design', slug: 'logo-design' },
//       { name: 'Website and App Design', slug: 'website-and-app-design' },
//       { name: 'Social Media Graphics', slug: 'social-media-graphics' },
//       { name: 'Print Materials Design', slug: 'print-materials-design' },
//       { name: 'Presentation Design', slug: 'presentation-design' },
//       { name: 'Brand Kit Development', slug: 'brand-kit-development' },
//       { name: 'Marketing Materials Design', slug: 'marketing-materials-design' },
//       { name: 'Video and Image Editing', slug: 'video-and-image-editing' }
//     ]
//   }
// ];

// const Header = () => {
//   const [hoveredServiceIndex, setHoveredServiceIndex] = useState(null);
//   const [isServicesHovered, setIsServicesHovered] = useState(false);
//   const [isProductsHovered, setIsProductsHovered] = useState(false);

//   return (
//   <header style={styles.siteHeader}>
//     <div style={styles.headerContainer}>
//       <nav style={{ display: 'flex', alignItems: 'center' }}>
//         {/* Website Image (Logo) */}
//        <Link to="/">
//             <img 
//               src={websiteLogo} 
//               alt="Website Logo" 
//               style={{ height: '60px', marginRight: '2rem' }} 
//             />
//           </Link>

//         {/* Navigation Menu */}
//         <ul style={styles.navList}>
//           <li><Link to="/" className="nav-link">Home</Link></li>
//           <li><Link to="/about-us" className="nav-link">About Us</Link></li>

//           {/* Services Dropdown */}
//           <li
//             style={{ position: 'relative' }}
//             onMouseEnter={() => setIsServicesHovered(true)}
//             onMouseLeave={() => {
//               setIsServicesHovered(false);
//               setHoveredServiceIndex(null);
//             }}
//           >
//             <Link to="/services" className="nav-link">Services</Link>
//             {isServicesHovered && (
//               <div style={styles.servicesDropdown}>
//                 <ul style={styles.servicesList}>
//                   {servicesData.slice(0, 6).map((service, index) => (
//                     <li
//                       key={service.id}
//                       style={{
//                         ...styles.serviceTitle,
//                         ...(hoveredServiceIndex === index ? styles.serviceTitleHover : {})
//                       }}
//                       onMouseEnter={() => setHoveredServiceIndex(index)}
//                       onMouseLeave={() => setHoveredServiceIndex(null)}
//                     >
//                       <Link 
//                         to={`/services/section/${service.id}`} 
//                         style={styles.serviceTitleLink}
//                         onClick={() => {
//                           setIsServicesHovered(false);
//                           setHoveredServiceIndex(null);
//                         }}
//                       >
//                         {service.title}
//                       </Link>
//                       {hoveredServiceIndex === index && (
//                         <ul style={styles.subItemsList}>
//                           {service.subItems.map((item, idx) => (
//                             <li
//                               key={idx}
//                               style={styles.submenuItem}
//                               onMouseEnter={e => {
//                                 e.currentTarget.style.backgroundColor = '#fdf1e8';
//                               }}
//                               onMouseLeave={e => {
//                                 e.currentTarget.style.backgroundColor = 'transparent';
//                               }}
//                             >
//                               <Link 
//                                 to={`/services/section/${service.id}#${item.slug}`} 
//                                 style={styles.submenuLink}
//                                 onClick={() => {
//                                   setIsServicesHovered(false);
//                                   setHoveredServiceIndex(null);
//                                 }}
//                               >
//                                 {item.name}
//                               </Link>
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </li>

//           {/* Products Dropdown */}
//           <li
//             style={{ position: 'relative' }}
//             onMouseEnter={() => setIsProductsHovered(true)}
//             onMouseLeave={() => setIsProductsHovered(false)}
//           >
//             <Link to="/products" className="nav-link">Products</Link>
//             {isProductsHovered && (
//               <ul style={styles.productSubmenu}>
//                 <li style={styles.submenuItem}>
//                   <Link to="/product-wedoo" style={styles.productsubmenuLink}>Wedoo</Link>
//                 </li>
//                 <li style={styles.submenuItem}>
//                   <Link to="/product-trustmee" style={styles.productsubmenuLink}>Trustmee</Link>
//                 </li>
//               </ul>
//             )}
//           </li>

//           <li><Link to="/careers" className="nav-link">Careers</Link></li>
//           <li><Link to="/contact-us" className="nav-link">Contact Us</Link></li>
//         </ul>
//       </nav>
//     </div>
//   </header>
// );

// };

// const styles = {
//   serviceTitleLink: {
//     textDecoration: 'none',
//     color: 'inherit',
//     display: 'block',
//     padding: '0px 2px',
//     borderRadius: '6px',
//     width: '100%',
//     height: '100%',
//   },
//   siteHeader: {
//     backgroundColor: 'white',
//     padding: '10px 0',
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     width: '100%',
//     zIndex: 1000
//   },
//   headerContainer: {
//     display: 'flex',
//     justifyContent: 'space-around',
//     alignItems: 'center',
//     margin: '0 auto'
//   },
//   navList: {
//     listStyle: 'none',
//     display: 'flex',
//     gap: '3.3rem',
//     width: "100%",
//     padding: 0,
//     margin: 0
//   },
//   servicesDropdown: {
//     position: 'absolute',
//     top: '100%',
//     left: 0,
//     backgroundColor: '#ffffff',
//     border: '1px solid #e87115',
//     borderRadius: '6px',
//     padding: '0px',
//     display: 'flex',
//     zIndex: 100,
//     cursor: "pointer",
//     fontFamily: 'Urbanist, sans-serif',
//   },
//   servicesList: {
//     listStyle: 'none',
//     margin: 0,
//     padding: 0,
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px'
//   },
//   serviceTitle: {
//     position: 'relative',
//     fontWeight: '600',
//     padding: '8px 12px',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     color: '#003e64',
//     whiteSpace: 'nowrap'
//   },
//   serviceTitleHover: {
//     backgroundColor: '#fdf1e8',
//     border: '1px solid #e87115',
//   },
//   subItemsList: {
//     position: 'absolute',
//     top: 0,
//     left: '100%',
//     backgroundColor: '#ffffff',
//     border: '1px solid #e87115',
//     borderRadius: '6px',
//     padding: '10px',
//     listStyle: 'none',
//     minWidth: '240px',
//     zIndex: 200,
//     boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
//   },
//   subItemsListHover: {
//     backgroundColor: '#fdf1e8',
//     border: '1px solid #e87115',
//   },
//   submenuItem: {
//     padding: '4px 0',
//     borderRadius: '4px',
//     transition: 'background-color 0.3s',
//   },

//   submenuLink: {
//     textDecoration: 'none',
//     color: '#003e64',
//     fontSize: '16px',
//     fontWeight: 500,
//     display: 'block',
//     padding: '6px 12px',
//     borderRadius: '4px',
//   },

//   submenuItemHover: {
//     backgroundColor: '#fdf1e8',
//   },
//   productSubmenu: {
//     position: 'absolute',
//     top: '100%',
//     left: '-1%',
//     backgroundColor: '#ffffff',
//     border: '1px solid #e87115',
//     borderRadius: '6px',
//     padding: '6px 10px',
//     boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
//     zIndex: 100,
//     minWidth: '140px',
//     listStyle: "none",
//     fontFamily: 'Urbanist, sans-serif',
//   },
//   productsubmenuLink: {
//     textDecoration: 'none',
//     color: '#003e64',
//     fontSize: '18px',
//     fontWeight: 600,
//     display: 'block',
//     padding: '3px 12px',
//   }
// };

// export default Header;





import '../styling/global.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import websiteLogo from '../assets/website_logo_header.png';

const servicesData = [
  {
    id: 1,
    title: 'AI & Data Services',
    subItems: [
      { name: 'Internet & Web Research Services', slug: 'internet-web-research-services' },
      { name: 'Sentiment Analysis', slug: 'sentiment-analysis' },
      { name: 'Search Relevance', slug: 'search-relevance' },
      { name: 'Search Data Testing', slug: 'search-data-testing' },
      { name: 'Product Data Management', slug: 'product-data-management' },
      { name: 'Store Checks', slug: 'store-checks' },
      { name: 'Mystery Checks', slug: 'mystery-checks' },
      { name: 'Surveys', slug: 'surveys' }
    ]
  },
  {
    id: 2,
    title: 'Data Annotation & Dataset Solutions',
    subItems: [
      { name: 'Categorization & Tagging', slug: 'categorization-tagging' },
      { name: 'Product Categorization & Tagging', slug: 'product-categorization-tagging' },
      { name: 'Image & Video Tagging', slug: 'image-video-tagging' },
      { name: 'Video Analysis', slug: 'video-analysis' },
      { name: 'Image Annotation', slug: 'image-annotation' },
      { name: 'Human in the Loop Services', slug: 'human-in-the-loop-services' },
      { name: 'AI Content Editing & Creation', slug: 'ai-content-editing-creation' }
    ]
  },
  {
    id: 3,
    title: 'AI Training Dataset Development',
    subItems: [
      { name: 'AI Datasets for ML', slug: 'ai-datasets-for-ml' },
      { name: 'Audio & Voice Datasets', slug: 'audio-voice-datasets' },
      { name: 'LLM Dataset Services', slug: 'llm-dataset-services' },
      { name: 'Image & Photo Datasets', slug: 'image-photo-datasets' },
      { name: 'Face Recognition Training Data', slug: 'face-recognition-training-data' },
      { name: 'Video Datasets', slug: 'video-datasets' }
    ]
  },
  {
    id: 4,
    title: 'Testing & Quality Assurance',
    subItems: [
      { name: 'Mobile App Testing', slug: 'mobile-app-testing' },
      { name: 'Store Checks (QA field audits)', slug: 'store-checks-qa-field-audits' },
      { name: 'Search Data Test', slug: 'search-data-test' },
      { name: 'Mystery Checks (Customer experience QA)', slug: 'mystery-checks-customer-experience-qa' }
    ]
  },
  {
    id: 5,
    title: 'App & Web Development',
    subItems: [
      { name: 'Mobile App Development (iOS & Android)', slug: 'mobile-app-development-ios-android' },
      { name: 'Website Development', slug: 'website-development' },
      { name: 'Web App UI/UX Design', slug: 'web-app-ui-ux-design' },
      { name: 'Template Design', slug: 'template-design' }
    ]
  },
  {
    id: 6,
    title: 'Creative & Graphic Design Services',
    subItems: [
      { name: 'Logo Design', slug: 'logo-design' },
      { name: 'Website and App Design', slug: 'website-and-app-design' },
      { name: 'Social Media Graphics', slug: 'social-media-graphics' },
      { name: 'Print Materials Design', slug: 'print-materials-design' },
      { name: 'Presentation Design', slug: 'presentation-design' },
      { name: 'Brand Kit Development', slug: 'brand-kit-development' },
      { name: 'Marketing Materials Design', slug: 'marketing-materials-design' },
      { name: 'Video and Image Editing', slug: 'video-and-image-editing' }
    ]
  }
];

const Header = () => {
  const [hoveredServiceIndex, setHoveredServiceIndex] = useState(null);
  const [isServicesHovered, setIsServicesHovered] = useState(false);
  const [isProductsHovered, setIsProductsHovered] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <nav>
          <Link to="/" onClick={closeMobileMenu}>
            <img
              src={websiteLogo}
              alt="Website Logo"
              className="logo-image"
            />
          </Link>

          {isMobileView ? (
            <div className="mobile-menu-wrapper">
              <button 
                className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>

              <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}>
                <ul className="mobile-nav-list">
                  <li><Link to="/" className="mobile-nav-link" onClick={closeMobileMenu}>Home</Link></li>
                  <li><Link to="/about-us" className="mobile-nav-link" onClick={closeMobileMenu}>About Us</Link></li>
                  <li><Link to="/services" className="mobile-nav-link" onClick={closeMobileMenu}>Services</Link></li>
                  <li><Link to="/products" className="mobile-nav-link" onClick={closeMobileMenu}>Products</Link></li>
                  <li><Link to="/careers" className="mobile-nav-link" onClick={closeMobileMenu}>Careers</Link></li>
                  <li><Link to="/contact-us" className="mobile-nav-link" onClick={closeMobileMenu}>Contact Us</Link></li>
                </ul>
              </div>
            </div>
          ) : (
           <ul className="nav-list">
              <li><Link to="/" className="nav-link">Home</Link></li>
              <li><Link to="/about-us" className="nav-link">About Us</Link></li>

              <li
                className="services-menu-item"
                onMouseEnter={() => setIsServicesHovered(true)}
                onMouseLeave={() => {
                  setIsServicesHovered(false);
                  setHoveredServiceIndex(null);
                }}
              >
                <Link to="/services" className="nav-link">Services</Link>
                {isServicesHovered && (
                  <div className="services-dropdown">
                    <ul className="services-list">
                      {servicesData.slice(0, 6).map((service, index) => (
                        <li
                          key={service.id}
                          className={`service-item ${hoveredServiceIndex === index ? 'active' : ''}`}
                          onMouseEnter={() => setHoveredServiceIndex(index)}
                          onMouseLeave={() => setHoveredServiceIndex(null)}
                        >
                          <Link
                            to={`/services/section/${service.id}`}
                            className="service-link"
                            onClick={() => {
                              setIsServicesHovered(false);
                              setHoveredServiceIndex(null);
                            }}
                          >
                            {service.title}
                          </Link>

                          {hoveredServiceIndex === index && (
                            <ul className="subservices-list">
                              {service.subItems.map((item, idx) => (
                                <li
                                  key={idx}
                                  className="subservice-item"
                                >
                                  <Link
                                    to={`/services/section/${service.id}#${item.slug}`}
                                    className="subservice-link"
                                    onClick={() => {
                                      setIsServicesHovered(false);
                                      setHoveredServiceIndex(null);
                                    }}
                                  >
                                    {item.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>

              <li
                className="products-menu-item"
                onMouseEnter={() => setIsProductsHovered(true)}
                onMouseLeave={() => setIsProductsHovered(false)}
              >
                <Link to="/products" className="nav-link">Products</Link>
                {isProductsHovered && (
                  <ul className="product-submenu">
                    <li className="submenu-item">
                      <Link to="/product-wedoo" className="product-submenu-link">Wedoo</Link>
                    </li>
                    <li className="submenu-item">
                      <Link to="/product-trustmee" className="product-submenu-link">Trustmee</Link>
                    </li>
                  </ul>
                )}
              </li>

              <li><Link to="/careers" className="nav-link">Careers</Link></li>
              <li><Link to="/contact-us" className="nav-link">Contact Us</Link></li>
            </ul>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;